var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcExpandMenu = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#6B7682",
  d: "M4.5 26.5v-20h23v20h-23Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#6B7682",
  d: "M14 8H6v17h8V8Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#6B7682",
  strokeWidth: 2,
  d: "m17.5 21.5 5-5-5-5"
})));
export { SvgIcExpandMenu as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTQuNSAyNi41VjYuNUgyNy41VjIzLjA2MjVWMjYuNUg0LjVaIiBzdHJva2U9IiM2Qjc2ODIiLz4KPHBhdGggZD0iTTE0IDhINlYyNUgxNFYyMS44MTI1VjhaIiBmaWxsPSIjNkI3NjgyIi8+CjxwYXRoIGQ9Ik0xNy41IDIxLjVMMjIuNSAxNi41TDE3LjUgMTEuNSIgc3Ryb2tlPSIjNkI3NjgyIiBzdHJva2Utd2lkdGg9IjIiLz4KPC9zdmc+Cg==";